/* eslint-disable */
export enum GSNHeader {
	NamespaceOverride = "X-GSN-WEBSTORE-NAMESPACE-OVERRIDE",
	DeviceType = "X-GSN-WEBSTORE-DEVICE-TYPE",
	BrowserType = "X-GSN-WEBSTORE-BROWSER-TYPE",
	SyntheticId = "X-GSN-WEBSTORE-SYNTHETIC-ID",
	SessionId = "X-SCOPELY-WEBSTORE-SESSION-ID",
	LaunchSource = "X-SCOPELY-WEBSTORE-LAUNCH-SOURCE",
	Platform = "X-SCOPELY-WEBSTORE-PLATFORM",
	sessionSequence = "X-SCOPELY-WEBSTORE-SESSION-REQUEST-SEQUENCE"
}

export enum ContentType {
	PlainText = "text/plain; charset=utf-8"
}
/* eslint-enable */
